import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import img1 from "../../assets/images/home-insurance/health-ins.webp"
import img2 from "../../assets/images/home-insurance/life-ins.webp"
import img3 from "../../assets/images/home-insurance/car-ins.webp"

function Customer() {
  const data = [
    {
      id: 1,
      img: img1,
      name: "Health Insurance",
    },
    {
      id: 2,
      img: img2,
      name: "Life Insurance",
    },
    {
      id: 3,
      img: img3,
      name: "Car Insurance",
    },
  ];

  return (
    <>
      <section className="portfolio-two">
        <div className="container-fluid">
          <Swiper
            spaceBetween={30} 
            slidesPerView={1}
            loop={true} 
            breakpoints={{
              576: {
                slidesPerView: 2, 
              },
              992: {
                slidesPerView: 3, 
              },
            }}
          >
            {data.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="portfolio-card portfolio-card--two portfolio-card--four">
                  <div className="portfolio-card__image">
                    <img src={item.img} alt={item.name} />
                    <div className="portfolio-card__content">
                      <h3 className="portfolio-card__title">
                        <Link to="/portfoliodetails">{item.name}</Link>
                      </h3>
                      <span className="portfolio-card__tagline">Insurance</span>

                      {/* <Link
                        to="/portfoliodetails"
                        className="portfolio-card__link"
                      >
                        <i className="far fa-arrow-right" />
                      </Link> */}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
    </>
  );
}

export default Customer;
